(function () {
  const wishlistTrigger = document.querySelector('[data-role="open-wishlist"]');
  const wishlistClose = document.querySelector('[data-role="close-wishlist"]');
  const wishlistModal = document.querySelector('wishlist-modal');
  wishlistTrigger.addEventListener('click', () => {
    wishlistModal.open();
  });
  wishlistClose.addEventListener('click', () => {
    wishlistModal.close();
  });
})();

class WishListModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('#wishlistModalBox');
    this.wishlistContainer = this.querySelector('.pf-wishlist-container');
    this.wishlistSliderContainer = this.querySelector('.pf-wishlist-slider-container');
    this.backToListButton = this.querySelector('.back-to-list');
    this.wishlistItemsContainer = this.querySelector('#wishlist-items-container');
    this.customWishlistSliders = this.querySelector('#custom-wishlist-sliders');
    this.emptyWishlistContainer = this.querySelector('.swym-empty-wishlist-container');
    this.footerWishlistSectionContainer = this.querySelector('.footer_wishlist_section_container');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.openCartDrawerTrigger = this.querySelector('[data-role="open-cart-drawer"]');
    this.addEventListeners();

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(this.swymRenderWishlist.bind(this));
  }

  productCardMarkup() {
    return `<div class="swym-wishlist-grid">
     {{#products}} 
     <a aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor" index="{{ cprops.index }}">
      <div class="left-content-wrapper" data-role="sub-modal-trigger" index="{{ cprops.index }}">
        <div class="swym-wishlist-image-wrapper">
          <img alt="" class="swym-wishlist-image" src="{{iu}}">
        </div>
        <div class="swym-text-content">
          <div class="swym-text-content-top">
            <button class="swym-is-button">
              <div class="swym-title swym-title-1">
                {{dt}}
              </div>
            </button>
          
            <div class="swym-product-price swym-text swym-text-1">
              <div class="swym-product-final-price swym-value">
                {{cu}}{{pr}}
              </div>
            </div>
            <div class="swym-color-element" data-processed="Hot Pink"><span>Color:</span> {{color}}</div>
          </div>
          <div class="swym-select-size">
            SELECT SIZE
          </div>
          </div>
        </div>
        <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
         <span class="swym-icon">
         </span>
       </button>
       
     </a>
     {{/products}}
  </div>`;
  }

  addEventListeners() {
    this.querySelector('[data-role="close-wishlist"]').addEventListener('click', () => this.close());
    this.backToListButton.addEventListener('click', () => this.backToList());
    this.openCartDrawerTrigger.addEventListener('click', () => this.openCartDrawer());
  }

  open() {
    this.style.visibility = 'visible';
    this.style.opacity = '1';
    this.renderWishlist();
  }

  close() {
    this.style.visibility = 'hidden';
    this.style.opacity = '0';
  }

  openCartDrawer() {
    this.close();
    this.cartDrawer.open();
  }

  async renderWishlist() {
    const products = await this.fetchWishlistProducts();
    this.activeWishListButton(products);
    const formattedWishlistedProducts = this.formatProducts(products);
    if (formattedWishlistedProducts.length === 0) {
      this.addEmptyCard();
    } else {
      this.hideEmptyCard();
      this.wishlistItemsContainer.innerHTML = this.renderProductCards(formattedWishlistedProducts);
      this.attachClickListeners();
    }
  }

  async fetchWishlistProducts() {
    return new Promise((resolve) => {
      window._swat.fetch((products) => resolve(products));
    });
  }

  formatProducts(products) {
    return products.map((p) => {
      const match = p.dt.split(' - ');
      p = SwymUtils.formatProductPrice(p);
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
      p.variantinfo = p.vi ? this.getVariantInfo(p.vi) : '';
      p['color'] = match && match.length > 2 ? match[2] : '';
      return p;
    });
  }

  getVariantInfo(variants) {
    try {
      let variantKeys = variants && variants != '[]' ? Object.keys(JSON.parse(variants)[0]) : [];
      let variantinfo = variantKeys.length > 0 ? variantKeys[0] : '';
      return variantinfo === 'Default Title' ? '' : variantinfo;
    } catch (err) {
      return variants;
    }
  }

  renderProductCards(products) {
    return SwymUtils.renderTemplateString(this.productCardMarkup(), { products });
  }

  attachClickListeners() {
    const addToCartButtons = this.querySelectorAll('#swym-custom-add-toCartBtn');
    const removeBtns = this.querySelectorAll('#swym-remove-productBtn');
    const subModalTriggers = this.querySelectorAll('[data-role="sub-modal-trigger"]');
    addToCartButtons.forEach((btn) => btn.addEventListener('click', (e) => this.onAddToCartClick(e), false));
    removeBtns.forEach((btn) => btn.addEventListener('click', (e) => this.onRemoveBtnClick(e), false));
    subModalTriggers.forEach((trigger, idx) => {
      // Add data attribute for position in list for easier identification
      trigger.setAttribute('data-position', idx);
      trigger.addEventListener('click', (e) => this.sub_modal(e), false);
    });
  }

  onAddToCartClick(e) {
    e.preventDefault();
    const productId = e.currentTarget.getAttribute('data-product-id');
    const variantId = e.currentTarget.getAttribute('data-variant-id');
    const du = e.target.getAttribute('data-product-url');
    e.target.innerHTML = 'Adding..';
    window._swat.replayAddToCart(
      { empi: productId, du },
      variantId,
      (c) => {
        e.target.innerHTML = 'Added to Cart';
        e.target.setAttribute('data-state-cart', 'swym-added');
        this.close();
      },
      (err) => console.error(err),
    );
  }

  onRemoveBtnClick(e) {
    e.preventDefault();
    const epi = +e.currentTarget.getAttribute('data-variant-id');
    const empi = +e.currentTarget.getAttribute('data-product-id');
    window._swat.fetch((products) => {
      products.forEach((product) => {
        if (epi && empi && product.epi == epi && product.empi == empi) {
          window._swat.removeFromWishList(product, () => {
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(() => this.renderWishlist());
          });
        }
      });
      if (window.location.href.includes('products')) {
        this.removeHighlightButton(empi);
      }
    });
  }

  activeWishListButton(products) {
    const heartIcons = document.querySelectorAll('.swym-wishlist');
    heartIcons.forEach((icon) => {
      icon.classList.toggle('is-active', products.length);
    });
  }

  addEmptyCard() {
    this.emptyWishlistContainer.style.display = 'flex';
    this.footerWishlistSectionContainer.style.display = 'none';
    this.wishlistContainer.style.display = 'none';
  }

  hideEmptyCard() {
    this.emptyWishlistContainer.style.display = 'none';
    this.footerWishlistSectionContainer.style.display = 'block';
    this.backToList();
  }

  backToList() {
    this.wishlistContainer.style.display = 'block';
    this.querySelector('.pf-wishlist-header h2').style.display = 'block';
    this.wishlistSliderContainer.style.display = 'none';
    this.backToListButton.style.display = 'none';
    this.customWishlistSliders.innerHTML = '';
  }

  swymRenderWishlist(swat) {
    // Get wishlist items
    swat.fetch((products) => {
      this.activeWishListButton(products);
      var formattedWishlistedProducts = products.map((p) => {
        const match = p.dt.split(' - ');

        p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
        p.variantinfo = p.vi ? this.getVariantInfo(p.vi) : '';
        p['color'] = match && match.length > 2 ? match[2] : '';
        return p;
      });

      if (formattedWishlistedProducts.length === 0) {
        this.addEmptyCard();
      } else {
        this.hideEmptyCard();
        if (window.location.href.includes('products')) {
          this.highlightButton(formattedWishlistedProducts);
        }
      }
      this.attachClickListeners(products);

      var productCardsMarkup = SwymUtils.renderTemplateString(this.productCardMarkup(), {
        products: formattedWishlistedProducts,
      });
      if (this.wishlistItemsContainer) {
        this.wishlistItemsContainer.innerHTML = productCardsMarkup;
        this.attachClickListeners();
      } else {
        console.log('Container not found, Wishlist Page element not found');
      }
    });
  }

  highlightButton(products) {
    const currentProduct = document.querySelector('wishlist-button');
    const producId = Number(currentProduct.dataset.productid);

    products.forEach((pro) => {
      if (pro.empi === producId) {
        currentProduct.classList.add('added-to-wishlist');
      }
    });
  }
  removeHighlightButton(empi) {
    const currentProduct = document.querySelector('wishlist-button');
    const producId = Number(currentProduct.dataset.productid);
    if (empi === producId) {
      currentProduct.classList.remove('added-to-wishlist');
    }
  }

  async sub_modal(event) {
    event.preventDefault();
    const elem = event.target.closest('.swym-wishlist-item');
    // Get both the index attribute and position in list
    const selectedIndex = Number(elem.getAttribute('index'));
    const selectedPosition = Number(elem.querySelector('[data-role="sub-modal-trigger"]').getAttribute('data-position'));
    const cartData = await fetch('/cart.js');
    const cart = await cartData.json();
    const cartVariantIds = new Set(cart.items.map((item) => item.variant_id));
    this.wishlistContainer.style.display = 'none';
    this.querySelector('.pf-wishlist-header h2').style.display = 'none';
    this.wishlistSliderContainer.style.display = 'block';
    this.backToListButton.style.display = 'flex';

    // Clear any existing product sliders
    this.customWishlistSliders.innerHTML = '';

    window._swat.fetch((products) => {
      products.forEach((product) => {
        product.cprops.variants.forEach((variant) => {
          variant.inCart = cartVariantIds.has(parseInt(variant.id, 10));
          variant.productSku = product.sku;
        });
      });

      // Determine which identification method to use
      const rearrangedProducts = this.getProductsWithSelectedFirst(products, selectedIndex, selectedPosition);

      rearrangedProducts.forEach((product) => {
        this.createProductSlider(product);
      });

      this.attachAddToCartListener();
      const paginationWrapper = this.querySelector('.wishlist-custom-pagination');
      if (products.length < 2) {
        paginationWrapper ? (paginationWrapper.style.display = 'none') : null;
      } else {
        paginationWrapper ? (paginationWrapper.style.display = 'flex') : null;
      }

      // Initialize main slider after all product sliders are created
      this.initializeMainSlider();
    });
  }

  // New separate method for initializing the main slider
  initializeMainSlider() {
    // Give a bit more time for DOM to update
    setTimeout(() => {
      try {
        const mainSlider = new Swiper(`.custom-wishlist-sliders-main`, {
          spaceBetween: 20,
          slidesPerView: 1,
          pagination: {
            el: '.wishlist-swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.wishlist-swiper-button-next',
            prevEl: '.wishlist-swiper-button-prev',
          },
          initialSlide: 0, // Ensure we start with the first slide (our selected product)
        });

        // Update the slider after initialization to ensure it renders correctly
        mainSlider.update();
      } catch (error) {
        console.error('Error initializing main slider:', error);
      }
    }, 50); // Increased timeout for better reliability
  }

  // New method that combines multiple approaches to find and reorder products
  getProductsWithSelectedFirst(products, indexAttribute, positionInList) {
    // Make a copy of the products array to avoid modifying the original
    const productsCopy = [...products];

    // Try multiple strategies to find the right product

    // 1. Try finding by cprops.index
    let productIndex = productsCopy.findIndex((product) => product.cprops.index === indexAttribute);

    // 2. If that fails, try using position in the list
    if (productIndex === -1 && positionInList >= 0 && positionInList < productsCopy.length) {
      //console.log('No exact index match found, using position in list:', positionInList);
      productIndex = positionInList;
    }

    // 3. As a last resort, just use the first product if we couldn't find a match
    if (productIndex === -1) {
      //console.log('Could not find matching product, defaulting to first product');
      return productsCopy;
    }

    // Move the identified product to the front
    const [selectedProduct] = productsCopy.splice(productIndex, 1);
    productsCopy.unshift(selectedProduct);

    return productsCopy;
  }

  // Keeping the old method for backward compatibility, but delegating to the new method
  moveProductToFirst(products, inputIndex) {
    return this.getProductsWithSelectedFirst(products, inputIndex, -1);
  }

  createProductSlider(product) {
    const {
      cprops: { images, variants },
    } = product;

    const thumbs = `
     <div thumbsSlider="" class="${product.sku}-thumbs" style="margin-right: 10px;">
          <div class="swiper-wrapper">
            ${images
              .slice(0, 6)
              .map((image, index) => {
                return `
                    <div class="swiper-slide" style="max-height:60px;opacity:0.4;">
                      <img src="${image}&width=100" width="50" height="60" style="min-width:50px;min-height:60px">
                    </div>`;
              })
              .join('')}
       </div>
      </div>
      `;

    const mainSlider = `
      <div class="${product.sku}-main main-slider-wishlist" style="overflow: hidden;">
          <div class="swiper-wrapper">
            ${images
              .slice(0, 6)
              .map((image, index) => {
                return `
                    <div class="swiper-slide">
                      <img src="${image}&width=350&height=438">
                    </div> `;
              })
              .join('')}
       </div>
      </div>
      `;
    let selectedVariant = false;
    let selectedVariantValue = '';
    let assigned = true;
    const joinSliders = `<div class="swiper-slide">
      <h3 class="pf-wishlist-product-title">${product.dt}</h3>
      <div class="custom-wishlist-slider">${thumbs}${mainSlider}</div>
      <div class="size-add-to-cart">
       <div class="wishlist-select-wrapper">
        <label class="size-label" for="size">Select Size:</label>
        <select id="product-options" class="product-options" data-role="handleSelectChange">
         ${variants
           .map((variant) => {
             if (variant.available && !selectedVariant && assigned) {
               selectedVariantValue = variant;
               selectedVariant = true;
             }

             const option = `<option value='${JSON.stringify(variant)}' ${selectedVariant && assigned ? 'selected' : ''} inCart="${variant.inCart}">${variant.title}</option>`;
             if (selectedVariant) {
               assigned = false;
             }
             return option;
           })
           .join('')}
        </select>
       </div>
       <button data-role="wishlistAddToCart" class="${product.sku}" id="swym-custom-add-to-cart-button" variant-id="${
         selectedVariantValue.id
       }" ${selectedVariantValue.inCart ? 'disabled' : ''}>${selectedVariantValue.inCart ? 'ADDED TO CART' : 'Add to Cart'}</button>
      
      </div>
    </div>`;

    document.getElementById('custom-wishlist-sliders').innerHTML += joinSliders;

    setTimeout(() => {
      var swiper = new Swiper(`.${product.sku}-thumbs`, {
        spaceBetween: 10,
        slidesPerView: 7,
        freeMode: true,
        direction: 'vertical',
      });
      new Swiper(`.${product.sku}-main`, {
        spaceBetween: 5,
        slidesPerView: 1,
        thumbs: {
          swiper: swiper,
        },
      });
    }, 10);
  }

  attachAddToCartListener() {
    const addToCartBtn = this.querySelectorAll("[data-role='wishlistAddToCart']");
    const productSelect = this.querySelectorAll("[data-role='handleSelectChange']");

    productSelect.forEach((select) => select.addEventListener('change', (event) => this.handleSelectChange(event)));
    addToCartBtn.forEach((btn) => btn.addEventListener('click', this.wishlist_add_to_cart.bind(this)));
  }

  async wishlist_add_to_cart(event) {
    event.preventDefault();

    let _esid;
    try {
      _esid = EasySizeParametersDebug.easysize.pageview_id.toString();
    } catch (e) {
      _esid = '-1';
    }
    try {
      const variantId = event.target.getAttribute('variant-id');
      event.target.classList.add('loading');
      const atcResponse = await fetch('/cart/add.js', {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              quantity: 1,
              id: variantId,
              properties: {
                _esid: _esid,
              },
            },
          ],
        }),
      });

      if (atcResponse.status == 200) {
        const data = await atcResponse.json();
        event.target.classList.remove('loading');
        this.close();
        //Open cart drawer
        // Fetch the updated cart data including the correct sections
        const response = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
        const sections = await response.json();

        // Check if the cart drawer element exists
        if (this.cartDrawer) {
          const updatedSections = {
            'cart-drawer': sections['cart-drawer'],
            'cart-icon-bubble': sections['cart-icon-bubble'],
          };

          // Ensure that the sections exist before updating the DOM
          if (updatedSections['cart-drawer'] && updatedSections['cart-icon-bubble']) {
            if (this.cartDrawer && this.cartDrawer.classList.contains('is-empty')) this.cartDrawer.classList.remove('is-empty');
            this.cartDrawer.renderContents({
              ...data.items[0],
              sections: updatedSections,
            });
          } else {
            console.error('Cart sections are missing in the response', sections);
          }
        }
      } else {
        throw new Error('Wishlist product not added to cart');
      }

      //custom_cart_data();
    } catch (err) {
      console.error(err);
    }
  }

  handleSelectChange(event) {
    const variant = JSON.parse(event.target.value);
    const button = event.target.closest('.size-add-to-cart').querySelector("[data-role='wishlistAddToCart']");

    if (variant.available) {
      if (!variant.inCart) {
        button.innerHTML = 'Add to Cart';
        button.removeAttribute('disabled');
        button.style.opacity = '1';
      } else {
        button.innerHTML = 'ADDED TO CART';
        button.setAttribute('disabled', true);
        button.style.opacity = '1';
      }
    } else {
      button.innerHTML = 'SOLD OUT';
      button.setAttribute('disabled', true);
      button.style.opacity = '0.8';
    }
    button.setAttribute('variant-id', variant.id);
  }
}

customElements.define('wishlist-modal', WishListModal);

class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.productData = JSON.parse(this.dataset.product);
    this.wishlistModal = document.querySelector('wishlist-modal');

    this.addEventListener('click', () => this.add_product_to_list(this.productData));
  }

  add_product_to_list(product) {
    if (this.classList.contains('added-to-wishlist')) {
      window._swat.fetchLists({
        callbackFn: (lists) => {
          this.removeProductFromList(lists[0].lid, product);
        },
        errorFn: function (error) {
          console.log('Error while fetching all Lists', error);
        },
      });

      return;
    }

    window._swat.fetchLists({
      callbackFn: (lists) => {
        if (lists.length) {
          this.addProductToList(lists[0].lid, product, lists[0].cnt);
        } else {
          this.createList(product);
        }
      },
      errorFn: function (error) {
        console.log('Error while fetching all Lists', error);
      },
    });
  }

  removeProductFromList(lid, product) {
    // Define the Product to be deleted
    let productobj = {
      epi: product.variants[0].id, // unique variant id  per listid
      empi: product.id, // product id
      du: `https://printfresh.com/products/${product.handle}`, // product url.
    };

    // Define success callback
    let onSuccess = async (deletedProduct) => {
      // Executed when product is successfully deleted
      this.classList.remove('added-to-wishlist');
      const products = await this.wishlistModal.fetchWishlistProducts();
      this.wishlistModal.activeWishListButton(products);
    };

    // Define error callback
    let onError = function (error) {
      // Error is an xhrObject
      console.error('Error while deleting the Product', error);
    };

    // Call `deleteFromList` using the above callbacks, lid and listItem
    window._swat.deleteFromList(lid, productobj, onSuccess, onError);
  }

  addProductToList(lid, product, productCount) {
    // Define the product object
    var listProduct = {
      dt: product.title, // Title of the product
      pr: product.price / 100, // Price of the product
      iu: product.featured_image, // Image URL of the product
      epi: product.variants[0].id, // Unique variant ID of the product
      empi: product.id, // Master Product Id of the product
      du: `${window.location.origin}/products/${product.handle}`, // Product URL
      cprops: {
        images: product.images,
        variants: product.variants,
        addToWishList: true,
        index: productCount + 1,
      },
    };

    // Define success callback
    let onSuccess = (addedListItem) => {
      // Success response is the added product.
      this.classList.add('added-to-wishlist');
      //$(".wishlist-thankyou-message").css("display", "block");

      setTimeout(() => {
        //$(".wishlist-thankyou-message").css("display", "none");
      }, 3000);

      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(this.wishlistModal.swymRenderWishlist.bind(this.wishlistModal));
    };

    // Define error callback
    let onError = function (error) {
      // Error is an xhrObj
      console.error('Error while adding the Product to the List', error);
    };

    // Call `addToList` with the above callbacks, lid and product object
    window._swat.addToList(lid, listProduct, onSuccess, onError);
  }

  createList(product) {
    const randomString = this.getRandomString(3, 50);
    // Define the list config
    let listConfig = {
      lname: randomString, // unique list name.
    };

    // Define success callback
    let onSuccess = (newList) => {
      this.addProductToList(newList.lid, product, newList.cnt);
    };

    // Define error callback
    let onError = function (error) {
      // Error is an xhrObject
      console.error('Error while creating a List', error);
    };

    // Create a new list with the above callbacks and config
    window._swat.createList(listConfig, onSuccess, onError);
  }

  getRandomString(minLength, maxLength) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    // Generate a random length between minLength and maxLength
    const length = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;

    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }
}

customElements.define('wishlist-button', WishlistButton);
